// Single source of truth for plans, derived directly from the finalized public
// pricing (PACKAGES in data.js). The public pricing section and /account/billing
// both read from this same source — no second, unrelated price list.
import { PACKAGES } from "@/lib/data";

export const PLANS = PACKAGES.map((p, i) => ({
  slug: p.id,                 // internal plan slug: starter | growth | pro
  name: p.name,               // display name
  price: p.price,             // monthly price, e.g. "€149"
  period: p.period,           // e.g. "per maand"
  perProperty: p.perProperty, // e.g. "€37,25 per listing"
  monthlyCredits: p.monthlyCredits, // monthly project credits
  benefits: p.features,       // included benefits (exact same as public site)
  recommended: !!p.recommended,
  badge: p.badge || null,     // recommended / lowest-price badge
  order: i,                   // display order
}));

export const PLAN_SLUGS = PLANS.map((p) => p.slug);

export const isValidPlan = (slug) => PLAN_SLUGS.includes(slug);

export const getPlan = (slug) => PLANS.find((p) => p.slug === slug) || null;
